<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
  >
    <v-card class="pa-5">
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <v-card-title class="justify-center">
        {{ $t('shareTemplateTitle') }}
      </v-card-title>
      <v-card-text class="text-center">
        {{ $t('shareTemplateText') }}
      </v-card-text>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn()"
          @submit.prevent
        >
          <v-text-field
            v-model="subdomain"
            data-testid="subdomain-input"
            solo
            hide-details="auto"
            class="rounded-xxl text-body-2 pt-4"
            :placeholder="$t('shareTemplateSpacePlaceholder')"
            :suffix="'.'+domain"
            @input="getSpaceText"
            :error-messages="errorsSubdomain"
            :rules="subdomainRules"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 cancel"
          :disabled="loading"
          @click="show=false"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          type="submit"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 submit create-template"
          :loading="loading"
          :disabled="loading"
          @click="submitDialogBtn()"
        >
          {{ $t('share') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired } from '../rules/formRules.js';
import i18n from '../plugins/i18n';
import AlertMessages  from './AlertMessages'
import { getSpaceByURLWithoutToken } from "../api/spaceApi";
import { shareTemplate } from "../api/activityApi";
import _ from 'lodash'

export default {
  components: {
        AlertMessages
    },
  props: {
    visible: Boolean,
    activityId: {
      type: String,
      default: "",
    },
    
  },
  data(){
      return{
          spaceId: window.$cookies.get('space_id'),
          valid: true,
          alertMsg:'',
          alertType:'',
          alertValue: false,
          loading: false,
          subdomain: '',
          domain: process.env.VUE_APP_DOMAIN,
          errorsSubdomain: [],
          subdomainRules: ruleRequired('labelSpace'),
          shareSpaceId: null,
          space: window.location.host.split('.')[0]
      }
    },    
    computed: {
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        }
    },

    methods: {
        
        async submitDialogBtn() {
            this.valid = this.$refs.form.validate()
            if(this.valid && this.errorsSubdomain.length == 0){
                this.loading = true
                await this.shareTemplate()
                this.loading = false
            }
        },
        getSpaceText: _.debounce(
          function () {
            if(this.subdomain == null || this.subdomain == ''){
              this.errorsSubdomain = []
            }
            if(this.subdomain != null && this.subdomain != ''){
              this.checkSpace();
            }
          },500
        ),
        async checkSpace() {
          if(this.subdomain == 'templates'){
            this.errorsSubdomain = [i18n.t('shareTemplateSpaceNotExists')]
          } else if(this.subdomain == this.space){
            this.errorsSubdomain = [i18n.t('shareTemplateSpaceSame')]
          }else{
            try {
              const response = await getSpaceByURLWithoutToken(this.subdomain);
              if (response.status) {
                if (response.status == 200) {
                  if(response.data.data.attributes.subscription_plan == 'Free'){
                    this.errorsSubdomain = [i18n.t('shareTemplateSpaceOnFreePlan')]
                  }else{
                    this.errorsSubdomain = []
                    this.shareSpaceId = response.data.data.id
                  }
                }
              }
            } catch (e) {
              if (e.response) {
                this.errorsSubdomain = [i18n.t('shareTemplateSpaceNotExists')]
              }
            }
          }
        },
        async shareTemplate(){
          try {
            let data = {
                data: {
                    type: "activities",
                    id: this.activityId, 
                    attributes: {
                        space_id: this.shareSpaceId
                    },
                    relationships: {
                        space: {
                            data: {
                                type: "spaces",
                                id: "" + this.spaceId + ""
                            }
                        }
                    }
                }
            };
            const response = await shareTemplate(this.activityId, data)
            if(response.status){
                if(response.status == 200) {
                    this.$emit('proceedSubmit')
                }
              }
            } catch (e) {
                if(e.response){
                    if (e.response.status == 422 ){
                        this.alertValue = true
                        this.alertType = 'error'
                        for(let i = 0; i < e.response.data.errors.length; i++){
                            if(e.response.data.errors[i].detail == "The space id has already been taken.") {
                                this.alertMsg =  i18n.t('shareTemplateSpaceAlreadyShared')
                            }else if(e.response.data.errors[i].detail == "The selected space id is invalid.") {
                                this.alertMsg =  i18n.t('shareTemplateSpaceNotExists')
                            }
                            else {
                                this.alertMsg =  i18n.t('serverError')
                            }
                        }
                    }else {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
          }
    },
}
</script>